import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) => state.tireTypeState || initialState;

export const selectTireTypeLoading = createSelector(
  [selectDomain],
  (tireTypeState) => tireTypeState.loading
);

export const selectTireTypeList = createSelector(
  [selectDomain],
  (tireTypeState) => tireTypeState.list
);

export const selectTireTypeMeta = createSelector(
  [selectDomain],
  (tireTypeState) => tireTypeState.meta
);

export const selectTireTypePage = createSelector(
  [selectDomain],
  (tireTypeState) => tireTypeState.page
);

export const selectTireTypePerPage = createSelector(
  [selectDomain],
  (tireTypeState) => tireTypeState.perPage
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (tireTypeState) => tireTypeState.isAddModalOpen
);

export const selectTireTypeForm = createSelector(
  [selectDomain],
  (tireTypeState) => tireTypeState.form
);

export const selectTireTypeSaving = createSelector(
  [selectDomain],
  (tireTypeState) => tireTypeState.saving
);
